export const PlatformData = [
  { id: '0', src: '/assets/trading_view.png', width: 235.53, height: 63.83 },
  // { id: '1', src: '/assets/tradovate.png', width: 231, height: 80 },
  // { id: '2', src: '/assets/ninjatrader.png', width: 265.46, height: 57 }, // COMMENTED OUT
  {
    id: '3',
    src: '/assets/volumetricatrading.png',
    width: 275.4,
    height: 68,
  },
  { id: '4', src: '/assets/volsys.png', width: 223.83, height: 57 },
  { id: '5', src: '/assets/volbook.png', width: 290.38, height: 68 },
  { id: '6', src: '/assets/trader_pro.png', width: 237, height: 91 },
];
